import { render, staticRenderFns } from "./BarberHairCareDataSheet.vue?vue&type=template&id=38887c2a"
import script from "./BarberHairCareDataSheet.vue?vue&type=script&lang=js"
export * from "./BarberHairCareDataSheet.vue?vue&type=script&lang=js"
import style0 from "./BarberHairCareDataSheet.vue?vue&type=style&index=0&id=38887c2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports